module.exports = __webpack_public_path__ + "img/SliderCutImg2.74a61e72.jpg";